import Styled from 'styled-components'
import { minQuery } from '../../../../helpers'

export default Styled.div`
    div.adminForm--container {
        padding: 4em;
        header {
            text-align: center;
            margin-bottom: 2em;
            h2 {
                margin-bottom: 0.5em;
                font-weight: 500;
                font-size: 1.4rem;
            }
            p {
                font-size: 0.9rem;
                color: rgba(255, 255, 255, 0.6);
            }
        }
        
        .progress-indicator {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 3em;
            
            .step {
                display: flex;
                flex-direction: column;
                align-items: center;
                
                .step-number {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    border: 2px solid rgba(255, 255, 255, 0.2);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 600;
                    color: rgba(255, 255, 255, 0.4);
                    margin-bottom: 0.5em;
                    transition: all 0.3s ease;
                }
                
                span {
                    font-size: 0.85rem;
                    color: rgba(255, 255, 255, 0.4);
                    transition: all 0.3s ease;
                }
                
                &.active {
                    .step-number {
                        border-color: var(--primary-color);
                        background: var(--primary-color);
                        color: #fff;
                    }
                    
                    span {
                        color: var(--primary-color);
                    }
                }
            }
            
            .step-line {
                width: 80px;
                height: 2px;
                background: rgba(255, 255, 255, 0.2);
                margin: 0 1em 1.5em 1em;
            }
        }
        
        .error-message {
            color: #ff6b6b;
            font-size: 0.85rem;
            margin-top: -1em;
            margin-bottom: 1em;
        }
        
        button {
            margin-top: 2em;
        }
        
        .button-row {
            display: flex;
            gap: 1em;
            margin-top: 2em;
            
            button {
                margin-top: 0;
                flex: 1;
                
                &.btn-secondary {
                    background: rgba(255, 255, 255, 0.1);
                    color: #fff;
                    border: 1px solid rgba(255, 255, 255, 0.2);
                    
                    &:hover {
                        background: rgba(255, 255, 255, 0.15);
                    }
                }
            }
        }
    }
    
    div.input-row {
        ${minQuery('lg')} {
            grid-gap: 1.5em;
            display: grid;
            grid-template-columns: 1fr 1fr;
        }
    }
    
    .input-group {
        margin-bottom: 1.5em;
        
        label {
            display: block;
            margin-bottom: 0.5em;
            font-size: 0.9rem;
            color: #fff;
            font-weight: 500;
        }
        
        .select-input {
            width: 100%;
            padding: 0.8em 1em;
            font-size: 0.95rem;
            border: 1px solid rgba(255, 255, 255, 0.2);
            border-radius: 8px;
            background: rgba(255, 255, 255, 0.05);
            color: #fff;
            outline: none;
            transition: all 0.2s ease;
            
            &:focus {
                border-color: var(--primary-color);
                background: rgba(255, 255, 255, 0.08);
            }
            
            option {
                background: #1a1a2e;
                color: #fff;
            }
        }
    }
`
